/**
 * Mock user data for development.
 * Provides realistic fitness-oriented user profiles.
 * The first user (MOCK_CURRENT_USER) is the logged-in persona.
 */
import { subMonths } from 'date-fns';

const now = new Date();

/**
 * The current mock user - represents the logged-in user.
 */
export const MOCK_CURRENT_USER_ID = 'mock_user_001';

export const MOCK_CURRENT_USER = {
  id: MOCK_CURRENT_USER_ID,
  displayName: 'Alex Rivera',
  username: 'alexrivera',
  email: 'alex.rivera@example.com',
  bio: 'Powerlifter | Software Engineer | Dog Dad | Chasing PRs and deadlines',
  avatarUrl: 'https://i.pravatar.cc/150?u=alexrivera',
  coverPhotoUrl: null,
  birthdate: '1993-06-15',
  gender: 'male',
  followersCount: 247,
  followingCount: 182,
  postsCount: 34,
  currentStreak: 12,
  longestStreak: 28,
  accountabilityPartnerId: 'mock_user_002',
  interests: ['strength', 'nutrition'],
  onboardingCompleted: true,
  createdAt: subMonths(now, 8).toISOString(),
};

/**
 * All mock users including the current user.
 */
export const MOCK_USERS = [
  MOCK_CURRENT_USER,
  {
    id: 'mock_user_002',
    displayName: 'Sarah Chen',
    username: 'sarahchen',
    email: 'sarah.chen@example.com',
    bio: 'Yoga instructor | Marathon runner | Plant-based nutrition advocate',
    avatarUrl: 'https://i.pravatar.cc/150?u=sarahchen',
    coverPhotoUrl: null,
    birthdate: '1990-03-22',
    gender: 'female',
    followersCount: 1243,
    followingCount: 341,
    postsCount: 156,
    currentStreak: 45,
    longestStreak: 45,
    accountabilityPartnerId: MOCK_CURRENT_USER_ID,
    createdAt: subMonths(now, 14).toISOString(),
  },
  {
    id: 'mock_user_003',
    displayName: 'Marcus Johnson',
    username: 'marcusj',
    email: 'marcus.j@example.com',
    bio: 'Former D1 athlete | Personal trainer | Helping others reach their potential',
    avatarUrl: 'https://i.pravatar.cc/150?u=marcusj',
    coverPhotoUrl: null,
    birthdate: '1988-11-05',
    gender: 'male',
    followersCount: 3421,
    followingCount: 289,
    postsCount: 312,
    currentStreak: 22,
    longestStreak: 60,
    accountabilityPartnerId: null,
    createdAt: subMonths(now, 18).toISOString(),
  },
  {
    id: 'mock_user_004',
    displayName: 'Priya Patel',
    username: 'priyapatel',
    email: 'priya.patel@example.com',
    bio: 'CrossFit enthusiast | Nutritionist | Mom of 2 | Early morning workout crew',
    avatarUrl: 'https://i.pravatar.cc/150?u=priyapatel',
    coverPhotoUrl: null,
    birthdate: '1991-08-12',
    gender: 'female',
    followersCount: 892,
    followingCount: 445,
    postsCount: 89,
    currentStreak: 7,
    longestStreak: 30,
    accountabilityPartnerId: null,
    createdAt: subMonths(now, 6).toISOString(),
  },
  {
    id: 'mock_user_005',
    displayName: 'Jake Thompson',
    username: 'jakethompson',
    email: 'jake.t@example.com',
    bio: 'Bodybuilding competitor | Meal prep king | NPC Men\'s Physique',
    avatarUrl: 'https://i.pravatar.cc/150?u=jakethompson',
    coverPhotoUrl: null,
    birthdate: '1995-01-30',
    gender: 'male',
    followersCount: 2156,
    followingCount: 198,
    postsCount: 203,
    currentStreak: 34,
    longestStreak: 90,
    accountabilityPartnerId: null,
    createdAt: subMonths(now, 11).toISOString(),
  },
  {
    id: 'mock_user_006',
    displayName: 'Elena Rodriguez',
    username: 'elenarodriguez',
    email: 'elena.r@example.com',
    bio: 'Olympic weightlifter | Sports science student | Coffee addict',
    avatarUrl: 'https://i.pravatar.cc/150?u=elenarodriguez',
    coverPhotoUrl: null,
    birthdate: '1997-04-18',
    gender: 'female',
    followersCount: 567,
    followingCount: 312,
    postsCount: 67,
    currentStreak: 15,
    longestStreak: 21,
    accountabilityPartnerId: null,
    createdAt: subMonths(now, 4).toISOString(),
  },
  {
    id: 'mock_user_007',
    displayName: 'David Kim',
    username: 'davidkim',
    email: 'david.kim@example.com',
    bio: 'Calisthenics | Gymnastics rings | Street workout | No gym needed',
    avatarUrl: 'https://i.pravatar.cc/150?u=davidkim',
    coverPhotoUrl: null,
    birthdate: '1994-09-08',
    gender: 'male',
    followersCount: 1890,
    followingCount: 156,
    postsCount: 145,
    currentStreak: 18,
    longestStreak: 50,
    accountabilityPartnerId: null,
    createdAt: subMonths(now, 10).toISOString(),
  },
  {
    id: 'mock_user_008',
    displayName: 'Olivia Foster',
    username: 'oliviafoster',
    email: 'olivia.f@example.com',
    bio: 'Pilates instructor | Wellness coach | Mind-body connection',
    avatarUrl: 'https://i.pravatar.cc/150?u=oliviafoster',
    coverPhotoUrl: null,
    birthdate: '1992-12-25',
    gender: 'female',
    followersCount: 734,
    followingCount: 267,
    postsCount: 98,
    currentStreak: 9,
    longestStreak: 25,
    accountabilityPartnerId: null,
    createdAt: subMonths(now, 7).toISOString(),
  },
  {
    id: 'mock_user_009',
    displayName: 'Ryan Mitchell',
    username: 'ryanmitchell',
    email: 'ryan.m@example.com',
    bio: 'Triathlete in training | Zone 2 cardio enthusiast | Data nerd',
    avatarUrl: 'https://i.pravatar.cc/150?u=ryanmitchell',
    coverPhotoUrl: null,
    birthdate: '1989-07-14',
    gender: 'male',
    followersCount: 423,
    followingCount: 189,
    postsCount: 76,
    currentStreak: 31,
    longestStreak: 31,
    accountabilityPartnerId: null,
    createdAt: subMonths(now, 5).toISOString(),
  },
  {
    id: 'mock_user_010',
    displayName: 'Jasmine Okafor',
    username: 'jasmineokafor',
    email: 'jasmine.o@example.com',
    bio: 'Track & field | Sprinter | Fueling with whole foods | Keep it moving',
    avatarUrl: 'https://i.pravatar.cc/150?u=jasmineokafor',
    coverPhotoUrl: null,
    birthdate: '1996-02-28',
    gender: 'female',
    followersCount: 1102,
    followingCount: 378,
    postsCount: 112,
    currentStreak: 14,
    longestStreak: 35,
    accountabilityPartnerId: null,
    createdAt: subMonths(now, 9).toISOString(),
  },
];

/**
 * Get a mock user by ID.
 * @param {string} userId
 * @returns {Object|null}
 */
export const getMockUserById = (userId) => {
  return MOCK_USERS.find((u) => u.id === userId) || null;
};

/**
 * Get a mock user by username.
 * @param {string} username
 * @returns {Object|null}
 */
export const getMockUserByUsername = (username) => {
  return MOCK_USERS.find((u) => u.username === username.toLowerCase()) || null;
};
